document.addEventListener("DOMContentLoaded", function () {

	//TOPに戻るボタン
	const pagetop_btn = document.querySelector(".pagetop");

	// スクロールされたら表示
	window.addEventListener("scroll", scroll_event);

	function scroll_event() {
		if (window.pageYOffset > 100) {
			//pagetop_btn.style.opacity = "1";
			pagetop_btn.classList.add('is-active');
		} else if (window.pageYOffset < 100) {
			//pagetop_btn.style.opacity = "0";
			pagetop_btn.classList.remove('is-active');
		}
	}
});

//footerのドロワーメニュー
window.addEventListener('load', function () {

	var footerHeadings = document.querySelectorAll('.footer-block__heading');

	footerHeadings.forEach(function (heading) {
		heading.addEventListener('click', function (event) {
			event.preventDefault(); // aタグの遷移を無効にする
			this.closest('.footer-block').classList.toggle('open');

			// URLの#を削除する
			if (window.location.hash) {
				history.pushState("", document.title, window.location.pathname + window.location.search);
			}
		});
	});
});


document.addEventListener("DOMContentLoaded", function () {
//ドメイン配下ではないURLのaタグには動的にtarget="_blank"を付与
document.querySelectorAll('a.full-unstyled-link, a.comp-btn__link').forEach(function(link) {
  var url = new URL(link.href);
  if (url.hostname !== window.location.hostname) {
	link.setAttribute('target', '_blank');
  }
});
});